var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPickFromData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3304 14.67C20.2804 13.62 19.4504 13.96 18.7304 14.67L14.5804 18.82C14.4204 18.98 14.2704 19.29 14.2304 19.51L14.0004 21.1C13.9204 21.67 14.3204 22.08 14.8904 21.99L16.4804 21.76C16.7004 21.73 17.0104 21.57 17.1704 21.41L21.3204 17.26C22.0504 16.55 22.3804 15.72 21.3304 14.67Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.74683 2.06549C7.29669 1.99425 7.75 2.45112 7.75 3.00557V6.8C7.75 7.35229 7.30228 7.8 6.75 7.8H3C2.44772 7.8 1.9918 7.35027 2.05867 6.80204C2.38633 4.11548 4.07187 2.41205 6.74683 2.06549Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.93 7.8H17.25C16.6977 7.8 16.25 7.35228 16.25 6.8V3.00625C16.25 2.45153 16.7041 1.99459 17.2542 2.06633C19.8878 2.40978 21.5645 4.0681 21.93 6.68C22.01 7.27 21.53 7.8 20.93 7.8Z",
    fill: "#292D32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 16.3008C7.30228 16.3008 7.75 16.7485 7.75 17.3008V20.9208C7.75 21.5208 7.22 22.0008 6.62 21.9208C4.05088 21.5385 2.43008 19.8918 2.07373 17.3109C1.99752 16.7589 2.4555 16.3008 3.01274 16.3008H6.75Z",
    fill: "#292D32"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 10.3008C7.75 9.7485 7.30228 9.30078 6.75 9.30078H3C2.44772 9.30078 2 9.7485 2 10.3008V13.8008C2 14.3531 2.44772 14.8008 3 14.8008H6.75C7.30228 14.8008 7.75 14.3531 7.75 13.8008V10.3008Z",
    fill: "#292D32"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 10.3008C14.75 9.7485 14.3023 9.30078 13.75 9.30078H10.25C9.69772 9.30078 9.25 9.7485 9.25 10.3008V13.8008C9.25 14.3531 9.69772 14.8008 10.25 14.8008H13.75C14.3 14.8008 14.75 14.3508 14.75 13.8008V10.3008Z",
    fill: "#292D32"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 3C14.75 2.44771 14.3023 2 13.75 2H10.25C9.69772 2 9.25 2.44772 9.25 3V6.8C9.25 7.35229 9.69772 7.8 10.25 7.8H13.75C14.3023 7.8 14.75 7.35228 14.75 6.8V3Z",
    fill: "#292D32"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickFromData);
export default __webpack_public_path__ + "static/media/PickFromData.45ed99d8.svg";
export { ForwardRef as ReactComponent };